export default "__VITE_ASSET__B1M9aceI__"